import React, { useState } from 'react';
import { ReactComponent as PersonIcon } from '../assets/person-silhouette.svg';
import { ReactComponent as PopcornIcon } from '../assets/popcorn.svg';
import { ReactComponent as TeddyBearIcon } from '../assets/teddy-bear.svg';
import { ReactComponent as PhotographIcon } from '../assets/photograph.svg';
import { ReactComponent as CokeIcon } from '../assets/coke-can.svg';
import { ReactComponent as JerseyIcon } from '../assets/basketball-jersey.svg';
import { ReactComponent as ClipboardIcon } from '../assets/clipboard.svg';
import { ReactComponent as HeadbandIcon } from '../assets/headband.svg';
import { ReactComponent as TrophyIcon } from '../assets/trophy.svg';

const MindPalaceVisualizer = () => {
  const [currentPosition, setCurrentPosition] = useState(0);
  
  const checkpoints = [
    { x: 150, y: 200, icon: PopcornIcon, label: "Popcorn", color: "#FF6B6B" },
    { x: 275, y: 100, icon: TeddyBearIcon, label: "Teddy Bear", color: "#9775FA" },
    { x: 400, y: 220, icon: PhotographIcon, label: "Photograph", color: "#4DABF7" },
    { x: 525, y: 120, icon: CokeIcon, label: "Coca Cola", color: "#FF8787" },
    { x: 650, y: 240, icon: JerseyIcon, label: "Jersey", color: "#748FFC" },
    { x: 775, y: 140, icon: ClipboardIcon, label: "Clipboard", color: "#3BC9DB" },
    { x: 900, y: 200, icon: HeadbandIcon, label: "Headband", color: "#20C997" },
    { x: 1025, y: 160, icon: TrophyIcon, label: "Trophy", color: "#FCC419" }
  ];

  const handleClick = () => {
    setCurrentPosition((prev) => (prev + 1) % checkpoints.length);
  };

  const characterPos = checkpoints[currentPosition];

  // Generate curved path string
  const pathString = checkpoints.reduce((path, point, i) => {
    if (i === 0) return `M ${point.x} ${point.y}`;
    const prev = checkpoints[i - 1];
    const midX = (prev.x + point.x) / 2;
    return `${path} C ${midX},${prev.y} ${midX},${point.y} ${point.x},${point.y}`;
  }, '');

  return (
    <div className="mind-palace-container" onClick={handleClick}>
      <h2>Mind Palace Journey</h2>
      <p className="mind-palace-description">
        Click anywhere to walk through your memory journey
      </p>
      
      <div className="mind-palace-visualizer">
        <svg className="journey-map" viewBox="0 0 1200 400">
          {/* Gradient definitions */}
          <defs>
            <linearGradient id="pathGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#9775FA" />
              <stop offset="100%" stopColor="#748FFC" />
            </linearGradient>
          </defs>

          {/* Connection path with gradient */}
          <path 
            className="journey-path" 
            d={pathString} 
            stroke="url(#pathGradient)"
          />

          {/* Updated Memory checkpoints with larger icons and labels */}
          {checkpoints.map((point, index) => {
            const Icon = point.icon;
            const isActive = index === currentPosition;
            const isPast = index < currentPosition;
            return (
              <g key={index} 
                 className={`memory-point ${isActive ? 'active' : ''} ${isPast ? 'past' : ''}`}
                 transform={`translate(${point.x - 25} ${point.y - 25})`}>
                <circle 
                  cx="25" 
                  cy="25" 
                  r="30" 
                  fill={point.color} 
                  opacity={isActive ? 1 : 0.3}
                  className="point-background"
                />
                <Icon width="50" height="50" className="point-icon" />
                <text 
                  y="80" 
                  x="25" 
                  textAnchor="middle" 
                  className="point-label"
                  fill={point.color}
                  style={{ 
                    fontWeight: 'bold',
                    fontSize: isActive ? '18px' : '16px',
                    opacity: isActive ? 1 : 0.8
                  }}>
                  {point.label}
                </text>
              </g>
            );
          })}

          {/* Moving character */}
          <g 
            className="memory-walker"
            transform={`translate(${characterPos.x - 20} ${characterPos.y - 20})`}
          >
            <circle cx="20" cy="20" r="23" className="walker-glow" />
            <PersonIcon width="40" height="40" />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default MindPalaceVisualizer; 